import dayjs from "dayjs";

import { formatIsoMonth } from "@/utils/date-format";

/** Resolve month from `?month=YYYY-MM`, falling back to the current calendar month. */
export function resolveStaffDashboardMonth(
  searchMonth: string | null | undefined,
  now: dayjs.ConfigType = dayjs()
): string {
  const trimmed = typeof searchMonth === "string" ? searchMonth.trim() : "";
  const match = /^(\d{4})-(\d{2})$/.exec(trimmed);
  if (match) {
    const monthNumber = Number(match[2]);
    if (monthNumber >= 1 && monthNumber <= 12) {
      const d = dayjs(`${trimmed}-01`);
      if (d.isValid() && d.month() + 1 === monthNumber) return trimmed;
    }
  }
  return formatIsoMonth(now);
}

/** Path to the staff Show dashboard, optionally preserving month. */
export function staffShowPath(employeeId: number | string, month?: string | null): string {
  const base = `/employees/${employeeId}/show`;
  const m = typeof month === "string" ? month.trim() : "";
  if (/^\d{4}-\d{2}$/.test(m)) {
    return `${base}?month=${m}`;
  }
  return base;
}

/** Path to the department attendance grid for a month (+ optional department). */
export function attendanceGridPath(month: string, department?: string | null): string {
  const params = new URLSearchParams();
  if (/^\d{4}-\d{2}$/.test(month)) {
    params.set("month", month);
  }
  const dept = typeof department === "string" ? department.trim() : "";
  if (dept && dept.toUpperCase() !== "ALL") {
    params.set("type", dept);
  }
  const qs = params.toString();
  return qs ? `/employeesAttendance?${qs}` : "/employeesAttendance";
}

export function daysInMonthFromKey(month: string): number[] {
  const end = dayjs(`${month}-01`).daysInMonth();
  const days: number[] = [];
  for (let d = 1; d <= end; d += 1) days.push(d);
  return days;
}

/** JS weekday (0=Sun … 6=Sat) of the 1st — empty cells before day 1 in a Sun–Sat grid. */
export function calendarLeadingPadCount(month: string): number {
  const d = dayjs(`${month}-01`);
  return d.isValid() ? d.day() : 0;
}

/** Empty cells after the last day so the final week row is complete. */
export function calendarTrailingPadCount(month: string): number {
  const days = daysInMonthFromKey(month).length;
  const leading = calendarLeadingPadCount(month);
  const rem = (leading + days) % 7;
  return rem === 0 ? 0 : 7 - rem;
}
